
<transition :appear="appear" :name="handleTransitionName()" @after-leave="$emit('afterLeave')"><slot /></transition>
